import axios from 'axios'

export default {
    namespaced: true,
    state: {
        financialAssistanceApplicationAttachments: [],
        financialAssistanceApplicationAttachment: {},
    },
    mutations: {
        SET_FINANCIAL_ASSISTANCE_APPLICATION_ATTACHMENTS(state, payload) {
            state.financialAssistanceApplicationAttachments = payload;
        },
        SET_FINANCIAL_ASSISTANCE_APPLICATION_ATTACHMENT(state, payload) {
            state.financialAssistanceApplicationAttachment = payload;
        },
    },
    actions: {
        async FetchFinancialAssistanceApplicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/attachments/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FINANCIAL_ASSISTANCE_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchFinancialAssistanceApplicationAttachments: ${error.message}`));
            });
        },
        async FetchFinancialAssistanceApplicationAttachment({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FINANCIAL_ASSISTANCE_APPLICATION_ATTACHMENT', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchFinancialAssistanceApplicationAttachment: ${error.message}`));
            });
        },
        async InsertFinancialAssistanceApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/attachments/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertFinancialAssistanceApplicationAttachment: ${error.message}`));
            });
        },
        async DeleteFinancialAssistanceApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/attachments/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteFinancialAssistanceApplicationAttachment: ${error.message}`));
            });
        },
    },
    getters: {
        FinancialAssistanceApplicationAttachments(state) { return state.financialAssistanceApplicationAttachments; },
        FinancialAssistanceApplicationAttachment(state) { return state.financialAssistanceApplicationAttachment; },
    }
}
